export const LoadingStatus = {
  data() {
    return {
      STATUS_INITIAL: 0,
      STATUS_LOADING: 1,
      STATUS_LOADED: 2,
      status: this.STATUS_INITIAL
    };
  },

  computed: {
    isInitialized() {
      return this.status > this.STATUS_INITIAL;
    },

    isLoading() {
      return this.status <= this.STATUS_LOADING;
    }
  },

  methods: {
    loadStart() {
      this.status = this.STATUS_LOADING;
    },
    loadEnd() {
      this.status = this.STATUS_LOADED;
    }
  }
};
